import React from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import EgwWebFont from "@/shared/assets/EgwWebFont";
import { useAudioContext } from "@/shared/contexts/AudioContext";
import { NEXT_URLS } from "@/utils/routes/routes.constants";
import { useAudioContextWithCurrentTime } from "@/shared/contexts/AudioContext.hooks";
import { isDeltaEquals } from "@/shared/utils/number/number";
import { dispatchWindowEventPlayAudioInReader } from "@/shared/utils/reader/reader";
import { PlayControls } from "@/shared/components/player/PlayerUIKit/PlayerUIKit";
import IconButton from "@/shared/components/IconButton/IconButton";

const useHandleClickPlayBtn = () => {
  const router = useRouter();
  const isReader = router.asPath.includes(NEXT_URLS.read);
  const { toggleChapterPlaying } = useAudioContext();

  return () => {
    if (isReader) {
      dispatchWindowEventPlayAudioInReader();
    } else {
      toggleChapterPlaying();
    }
  };
};

export const PlayControl = () => {
  const { t } = useTranslation();

  const { isPlaying } = useAudioContext();

  const handleClickPlay = useHandleClickPlayBtn();

  return (
    <IconButton
      className="header__btn-play"
      icon={isPlaying ? EgwWebFont["pause-circle"] : EgwWebFont["play-header"]}
      title={isPlaying ? t("pause") : t("play")}
      active={isPlaying}
      onClick={handleClickPlay}
    />
  );
};

const SKIP = 10;

const PlayerControls = ({ className }) => {
  const {
    isPlaying, seekPlayer, skipPlayer, canSeekBack, canSeekForward,
    timePosition, duration
  } = useAudioContextWithCurrentTime(useAudioContext(), {
    enabled: true,
    delayUpdateTime: 1000,
  });
  const handleClickPlay = useHandleClickPlayBtn();

  return (
    <PlayControls
      className={className}
      style={{ width: "unset", gridColumnGap: "0", padding: "0 0.45rem", }}

      isAudioPlaying={isPlaying}

      isSeekBackDisabled={!canSeekBack}
      onSeekPrevClick={() => seekPlayer(false)}

      isSkipBackDisabled={!canSeekBack && timePosition < 0.8}
      onSkipPrevClick={() => skipPlayer(-SKIP)}

      onTogglePlayClick={handleClickPlay}

      isSkipForwardDisabled={!canSeekForward && isDeltaEquals(timePosition, duration, 0.8)}
      onSkipNextClick={() => skipPlayer(SKIP)}

      isSeekForwardDisabled={!canSeekForward}
      onSeekNextClick={() => seekPlayer(true)}
    />
  );
};

export default PlayerControls;
